module.exports = __webpack_public_path__ + "assets/img/favicon/favicon.a475e8fb6e5334b991f79ffc593b2c53.ico";